<template>
    <div class="text-center">
        <div class="logo-wrapper ma-auto mt-n3 pa-5 primary" style="width: 115px;"><img :src="require('@/assets/logo_text.svg')"/></div>
        <h1 class="white--text display-1 text-center mt-12">Wie ben jij, bij Kings Code?</h1>
        <div class="white--text headline text-center mt-8">Beantwoord 14 vragen over jezelf en kom erachter welke Kings
            Coder jij bent!
        </div>
        <v-btn color="secondary" class="mt-12 primary--text font-weight-bold" x-large :to="{name: 'quiz'}">Spelen
        </v-btn>
    </div>
</template>

<script>
export default {
    name: 'Intro',
};
</script>

<style scoped>

</style>
